<template>
  <div class="web-promo-card-wrapper" :class="css">
    <div
      class="web-promo-card"
      :class="[cardCss, { 'web-promo-card--clickable': isCardClickable }]"
      :style="cardStyle"
      @click="handleCardClick"
    >
      <div class="web-promo-card__overlay">
        <div class="web-promo-card__content">
          <h3
            v-if="title"
            class="web-promo-card__title"
            :class="titleClass"
            :style="{ color: resolvedTextColor }"
          >
            {{ title }}
          </h3>
          <p
            v-if="text"
            class="web-promo-card__text"
            :class="textClass"
            :style="{ color: resolvedMutedTextColor }"
          >
            {{ text }}
          </p>
          <button
            v-if="showButton"
            type="button"
            class="btn web-promo-card__button"
            :class="buttonClass"
            @click.stop="handleLink"
          >
            {{ buttonText || "Ver más" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    css: {
      type: String,
      default: "",
    },
    cardCss: {
      type: String,
      default: "",
    },
    titleClass: {
      type: String,
      default: "",
    },
    textClass: {
      type: String,
      default: "",
    },
    buttonClass: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    src: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "#f9d5e5",
    },
    linkMode: {
      type: String,
      default: "button",
    },
  },
  computed: {
    isCardClickable() {
      return !!this.to && this.linkMode === "card";
    },
    showButton() {
      return !!this.to && this.linkMode !== "card";
    },
    cardStyle() {
      return {
        backgroundColor: this.bgColor || "transparent",
        backgroundImage: this.src ? `url(${this.src})` : "none",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    },
    hasImage() {
      return !!String(this.src || "").trim();
    },
    resolvedTextColor() {
      if (this.hasImage) return "#ffffff";
      return this.getReadableTextColor(this.bgColor);
    },
    resolvedMutedTextColor() {
      if (this.hasImage) return "rgba(255, 255, 255, 0.92)";
      return this.getReadableTextColor(this.bgColor, 0.86);
    },
  },
  methods: {
    getReadableTextColor(color = "", alpha = 1) {
      const normalized = String(color || "").replace("#", "").trim();
      if (!/^[0-9a-f]{6}$/i.test(normalized)) {
        return alpha === 1 ? "#1f2937" : "rgba(31, 41, 55, 0.86)";
      }

      const r = parseInt(normalized.slice(0, 2), 16);
      const g = parseInt(normalized.slice(2, 4), 16);
      const b = parseInt(normalized.slice(4, 6), 16);
      const luminance = (r * 299 + g * 587 + b * 114) / 1000;

      if (luminance > 170) {
        return alpha === 1 ? "#1f2937" : `rgba(31, 41, 55, ${alpha})`;
      }

      return alpha === 1 ? "#ffffff" : `rgba(255, 255, 255, ${alpha})`;
    },
    handleCardClick() {
      if (!this.isCardClickable) return;
      this.handleLink();
    },
    handleLink() {
      if (!this.to) return;
      if (this.to.indexOf("http") > -1) window.open(this.to, "_blank");
      else this.$router.push(this.getLink(this.to));
    },
  },
};
</script>

<style scoped>
.web-promo-card-wrapper {
  width: 100%;
}

.web-promo-card {
  width: 100%;
  min-height: 220px;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  /* box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12); */
}

.web-promo-card--clickable {
  cursor: pointer;
}

.web-promo-card__overlay {
  width: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  padding: 1.75rem;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.14) 0%,
    rgba(255, 255, 255, 0.04) 55%,
    rgba(255, 255, 255, 0) 100%
  );
}

.web-promo-card__content {
  max-width: 60%;
}

.web-promo-card__title {
  margin-bottom: 0.65rem;
  font-size: clamp(1.55rem, 2.5vw, 3.1rem);
  font-weight: 800;
  line-height: 0.95;
}

.web-promo-card__text {
  margin-bottom: 1rem;
  font-size: clamp(0.96rem, 1.35vw, 1.1rem);
}

.web-promo-card__button {
  border: 0;
  border-radius: 999px;
  padding: 0.8rem 1.4rem;
  background: #ffffff;
  color: #111827;
  font-weight: 700;
  box-shadow: 0 10px 24px rgba(17, 24, 39, 0.12);
}

@media (max-width: 767px) {
  .web-promo-card,
  .web-promo-card__overlay {
    min-height: 190px;
  }

  .web-promo-card__content {
    max-width: 100%;
  }
}
</style>
